import { actionCreatorFactory } from 'typescript-fsa';
import type { LogLevel } from 'utils/debug';

const actionCreator = actionCreatorFactory('timely/toast');

export type ToastType = 'success' | 'danger' | 'warning' | 'info' | 'neutral';

export interface Toast {
  key: string;
  message: string;
  title?: string;
  action?: string;
  type?: ToastType;
  logLevel?: LogLevel;

  /**
   * Number of milliseconds before the toast is automatically dismissed.
   * If set to zero or a negative number, the toast must be dismissed manually.
   * @default 7000
   */
  dismissAfter?: number;
}
export type CreateToastOptions = Omit<Toast, 'key'>;

export interface ToastsState {
  entries: Array<Toast>;
}

export const addToast = actionCreator<Toast>('SHOW');
export const dismissToast = actionCreator<{ key: string }>('HIDE');
export const persistToast = actionCreator<{ key: string }>('PERSIST');
